export default __webpack_public_path__ + "static/media/sendo.77d84609.png";